import React, { useEffect, useState } from "react";
import "./Resume.css";
import resumeData from "../../../resumeData/resumeData";
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@material-ui/icons/Work';

const Resume = () => {
  const resume = resumeData[0];
  const skillmessage = resume.skillmessage;

  const [scroll, setScroll] = useState(0);

  function handleScroll(event) {
    setScroll(window.scrollY - 2700);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const education = resume.education.map((education, index) => {
    return (
      <div key={education.school+index} className="education" data-aos="fade-up" data-aos-offset="0" data-aos-delay="0">
        <h3> {education.school} </h3>
        <p className="info">
          {education.degree}
          <span>&bull;</span> <em className="date"> {education.graduated} </em>{" "}
        </p>
        <p className="description">{education.description} </p>
      </div>
    );
  });
  const work = resume.work.map((work) => {
    return (
      <div key={work.company} className="education" data-aos="fade-up" data-aos-offset="0" data-aos-delay="0">
        <h3> {work.company} </h3>
        <p className="info">
          {" "}
          {work.title}
          <span>&bull;</span>
          <em className="date"> {work.years} </em>{" "}
        </p>
        <p className="description"> {work.description} </p>
      </div>
    );
  });


  return (
    <section id="resume">
      <div className="container-fluid">
        {/* Header and Text animation section */}
        <div className="scroll-text" >
          <p className=""
            style={{ transform: `translateX(${scroll}%)` }}
          >
            RESUME
          </p>
        </div>
        <h2
          style={{
            color: "#00ffd5",
            textAlign: "center",
            marginTop: "-60px",
            marginBottom: "80px",
            fontSize: '36px',
            position: 'relative',
            zIndex: 2,
          }}
        >
          MY RESUME
          <div style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}>
            <div className="main">
              <div className="ball"></div>
            </div>
          </div>
        </h2>
        {/* Resume section */}
        <div className="row resume-container-top">
          <div className="col-md-6">
            <h1 className="pb-3 header-col">
              <p>
                <SchoolIcon/>
                Educational Accomplishment
              </p>
            </h1>
            <div style={{ color: "#00ffd5" }}>{education}</div>
          </div>
          <div className="col-md-6">
            <h1 className="pb-3 header-col">
              <p>
              <WorkIcon />
              Working Experience
              </p>
            </h1>
            <div style={{ color: "#00ffd5" }}>{work}</div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Resume;
